import type {ExtractionDiagnosticoFields} from './ExtractionDiagnosticoSection';
import {filledExtractedFieldsFirst, renderExtractedCard} from './DocTypeExtractedViewShared';

type EstadoCivilDocTypeExtractedViewProps = {
    extractedData: unknown;
    diagnostico?: ExtractionDiagnosticoFields | null;
};

const ESTADO_CIVIL_FIELDS = [
    {label: 'Nome Conjuge', aliases: ['nome_conjuge', 'spouse_name', 'conjuge']},
    {label: 'CPF Conjuge', aliases: ['cpf_conjuge', 'spouse_cpf', 'cpf_do_conjuge']},
    {label: 'Data', aliases: ['data_evento', 'event_date', 'data_casamento', 'marriage_date']},
    {label: 'Regime de Bens', aliases: ['regime_bens', 'regime_de_bens', 'assets_regime']},
    {label: 'Possui Averbação de Divórcio?', aliases: ['possui_averbacao_divorcio', 'averbacao_divorcio', 'has_divorce_annotation']}
] as const;

export function EstadoCivilDocTypeExtractedView({
    extractedData,
    diagnostico
}: EstadoCivilDocTypeExtractedViewProps) {
    return (
        <div className="space-y-2">
            {filledExtractedFieldsFirst(ESTADO_CIVIL_FIELDS, extractedData).map((field) => renderExtractedCard(field, extractedData, diagnostico))}
        </div>
    );
}
